import { GetterTree } from "vuex/types";
import { RootState } from "@/store/types";
import { AccessControlState } from "./types";
import _ from "lodash";

/**
 * Getters for the Access Control module.
 * Provides computed access to user management data.
 */
const getters: GetterTree<AccessControlState, RootState> = {
  /**
   * Returns the current list of users with transformed roles.
   *
   * @param {AccessControlState} state - Module state
   * @returns {Array} Array of user objects
   */
  users(state) {
    return state.auth0.users;
  },

  /**
   * Returns the static copy of users for comparison/reset.
   *
   * @param {AccessControlState} state - Module state
   * @returns {Array} Array of user objects (unchanged)
   */
  usersStatic(state) {
    return state.auth0.usersStatic;
  },

  /**
   * Returns the total count of users for pagination.
   *
   * @param {AccessControlState} state - Module state
   * @returns {number} Total user count
   */
  total(state) {
    return state.auth0.total;
  }
};

export default getters;
